import { Widget, WidgetHeader, WidgetBody } from "../ui/Widget"
import VCIDealerRow from "../VCI/Dealers/VCIDealerRow"
import { adaptTrailerLocation } from "../../utilities/auditDealerAdapters"

export default function OtherLocationsWidget({ locations = [], isFetching }) {
  if (!locations.length && !isFetching) { return null }

  const adaptedLocations = locations.map(adaptTrailerLocation)

  return (
    <Widget>
      <WidgetHeader title="Other Locations" showSpinner={isFetching} />
      <WidgetBody>
        {adaptedLocations.map((location, index) => (
          <VCIDealerRow key={`${location.key}-${index}`} dealer={location} searchTerm="" />
        ))}
      </WidgetBody>
    </Widget>
  )
}
